import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {useServicesFactoryStore}  from '@/store/services-factory-store';
  import IDataBaseService from '@/model/services/IDataBaseService';
  //import { onMounted } from 'vue';
  import { ISesionApp } from '@/model/ISesionApp';
  import {useMainStore} from '@/store/main-store';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'View1Component',
  setup(__props) {
  
  const sesion:ISesionApp|null = useMainStore().getSesionApp;
  const dbService:IDataBaseService|any = useServicesFactoryStore().getDBService;
  const syncLocalService = useServicesFactoryStore().getSynLocalDBService;
  //const login = useServicesFactoryStore().getLoginService;
  //let sesion =ref<ISesionApp|null>(null);// await login.getSession();
  const test=()=>
  {
    throw 'asdasdasd';
  }
  const test2= ()=>
  {
    dbService.test();
  }
  const test22 = async ()  =>
  {
    const sync = await syncLocalService.SincronizaInformacionAsyn();
    console.log(sync);
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(" Componente 1 "),
    _createElementVNode("b", null, _toDisplayString(_unref(sesion)?.User?.FullName()), 1),
    _createElementVNode("h4", null, _toDisplayString(_unref(sesion)?.User?.AppUsuarioId), 1),
    _createElementVNode("button", {
      class: "btn btn-warning",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (test()))
    }, "test 22"),
    _createElementVNode("button", {
      class: "btn btn-warning",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (test2()))
    }, "DB"),
    _createElementVNode("button", {
      class: "btn btn-danger",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (test22()))
    }, "Sincronizar")
  ]))
}
}

})